import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

export default class IntermissionText extends BaseOption {
  static userInterfaceComponent = {
    label: "Break screen text",
    optionDataType: BaseOption.DataType.String,
    component: inspectorTools.SIMPLE_INPUT,
    descriptionMessage: "The headline viewers read during a break. Leave it empty for the default: We’ll be right back.",
  };

  static defaultValue = "";

  static convertConfigValueToCompiledValue(configValue) {
    if (configValue === "none" || configValue === null || configValue === undefined) {
      return "";
    }
    return String(configValue);
  }
}
